import React from "react";
import "./Spinner.css";

const Spinner = ({ fullscreen = false, size = 40, color = "#3550e9" }) => {
  return (
    <div className={fullscreen ? "spinner-overlay" : "spinner-wrapper"}>
      <div
        className="spinner"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      ></div>
    </div>
  );
};

export default Spinner;  // ⬅️ pastikan ada ini
